"use strict";

var siIndex = document.querySelector(".index");
if (siIndex) {
  //Anim des titres
  let glowInTexts = document.querySelectorAll(".titleAnim");

  // on coupe la phrase en differents span
  glowInTexts.forEach((glowInText) => {
    let letters = glowInText.textContent.split("");
    glowInText.textContent = "";
    letters.forEach((letter, i) => {
      let span = document.createElement("span");
      span.textContent = letter;
      span.style.animationDelay = `${i * 0.2}s`;
      glowInText.append(span);
    });
  });

  //Rewrite

  class TextScramble {
    constructor(el) {
      this.el = el;
      this.chars = "!<>-_\\/[]{}—=+*^?#________";
      this.update = this.update.bind(this);
    }

    setText(newText) {
      const oldText = this.el.innerText;
      const length = Math.max(oldText.length, newText.length);
      const promise = new Promise((resolve) => (this.resolve = resolve));
      this.queue = [];

      for (let i = 0; i < length; i++) {
        const from = oldText[i] || "";
        const to = newText[i] || "";
        const start = Math.floor(Math.random() * 40);
        const end = start + Math.floor(Math.random() * 40);
        this.queue.push({ from, to, start, end });
      }

      cancelAnimationFrame(this.frameRequest);
      this.frame = 0;
      this.update();
      return promise;
    }

    update() {
      let output = "";
      let complete = 0;

      for (let i = 0, n = this.queue.length; i < n; i++) {
        let { from, to, start, end, char } = this.queue[i];

        if (this.frame >= end) {
          complete++;
          output += to;
        } else if (this.frame >= start) {
          if (!char || Math.random() < 0.28) {
            char = this.randomChar();
            this.queue[i].char = char;
          }
          output += `<span class="dud">${char}</span>`;
        } else {
          output += from;
        }
      }

      this.el.innerHTML = output;
      if (complete === this.queue.length) {
        this.resolve();
      } else {
        this.frameRequest = requestAnimationFrame(this.update);
        this.frame++;
      }
    }

    randomChar() {
      return this.chars[Math.floor(Math.random() * this.chars.length)];
    }
  }

  // Liste de phrases spécifiques à dire (1 et 2)
  const phrasesList = [
    ["Introduction", "Le TDAH"],
    ["Mais d'abord...", "C'est quoi le TDAH ?"],
    ["Origine du projet", "Nos recherches"],
  ];

  // Sélectionne les éléments à animer
  const elements = document.querySelectorAll(".titleAnim");

  elements.forEach((el, index) => {
    const fx = new TextScramble(el);
  
    // Vérifier que l'index est valide dans phrasesList
    const phrases = phrasesList[index];
    if (!phrases) {
      return; // Sort de la boucle pour cet élément
    }
  
    let counter = 0;
    const next = () => {
      fx.setText(phrases[counter]).then(() => {
        setTimeout(next, 800);
      });
      counter = (counter + 1) % phrases.length;
    };
  
    next();
  });
  

  // face à face

  function adjustStickyPosition() {
    var contentLeft = document.querySelector("#left-content");
    var height = contentLeft.clientHeight;
    var topOffset = "calc(50% - " + height / 2 + "px)";
    contentLeft.style.top = topOffset;
  }

  function initialize() {
    adjustStickyPosition();
  }

  window.onload = initialize;
  window.onresize = initialize;

  // les cartes
  // var arrowFronts = document.querySelectorAll('.arrowFront');
  // var arrowBacks = document.querySelectorAll('.arrowBack');

  // arrowFronts.forEach(function(arrow) {
  //   arrow.addEventListener('click', function() {
  //     var lesmembres = this.closest('.members__content--iner');

  //     lesmembres.classList.remove('flipBack');
  //     lesmembres.classList.add('flipFront');
  //   });
  // });

  // arrowBacks.forEach(function(arrow) {
  //   arrow.addEventListener('click', function() {

  //     var lesmembresback = this.closest('.members__content--iner');

  //     lesmembresback.classList.remove('flipFront');
  //     lesmembresback.classList.add('flipBack');
  //   });
  // });

  var cursor = {
    delay: 1,
    _x: 0,
    _y: 0,
    endX: window.innerWidth / 2,
    endY: window.innerHeight / 2,
    cursorVisible: true,
    cursorEnlarged: false,
    $dot: document.querySelector(".cursor-dot"),
    $outline: document.querySelector(".cursor-dot-outline"),

    init: function () {
      // Set up element sizes
      this.dotSize = this.$dot.offsetWidth;
      this.outlineSize = this.$outline.offsetWidth;

      this.setupEventListeners();
      this.animateDotOutline();
    },

    setupEventListeners: function () {
      var self = this;

      // Anchor hovering
      document.querySelectorAll("a").forEach(function (el) {
        el.addEventListener("mouseover", function () {
          self.cursorEnlarged = true;
          self.toggleCursorSize();
        });
        el.addEventListener("mouseout", function () {
          self.cursorEnlarged = false;
          self.toggleCursorSize();
        });
      });

      // Click events
      document.addEventListener("mousedown", function () {
        self.cursorEnlarged = true;
        self.toggleCursorSize();
      });
      document.addEventListener("mouseup", function () {
        self.cursorEnlarged = false;
        self.toggleCursorSize();
      });

      document.addEventListener("mousemove", function (e) {
        // Show the cursor
        self.cursorVisible = true;
        self.toggleCursorVisibility();

        // Position the dot
        self.endX = e.pageX;
        self.endY = e.pageY;
        self.$dot.style.top = self.endY + "px";
        self.$dot.style.left = self.endX + "px";
      });

      // Hide/show cursor
      document.addEventListener("mouseenter", function (e) {
        self.cursorVisible = true;
        self.toggleCursorVisibility();
        self.$dot.style.opacity = 1;
        self.$outline.style.opacity = 1;
      });

      document.addEventListener("mouseleave", function (e) {
        self.cursorVisible = true;
        self.toggleCursorVisibility();
        self.$dot.style.opacity = 0;
        self.$outline.style.opacity = 0;
      });
    },

    animateDotOutline: function () {
      var self = this;

      self._x += (self.endX - self._x) / self.delay;
      self._y += (self.endY - self._y) / self.delay;
      self.$outline.style.top = self._y + "px";
      self.$outline.style.left = self._x + "px";

      requestAnimationFrame(this.animateDotOutline.bind(self));
    },

    toggleCursorSize: function () {
      var self = this;

      if (self.cursorEnlarged) {
        self.$dot.style.transform = "translate(-50%, -50%) scale(0.75)";
        self.$outline.style.transform = "translate(-50%, -50%) scale(1.5)";
      } else {
        self.$dot.style.transform = "translate(-50%, -50%) scale(1)";
        self.$outline.style.transform = "translate(-50%, -50%) scale(1)";
      }
    },

    toggleCursorVisibility: function () {
      var self = this;

      if (self.cursorVisible) {
        self.$dot.style.opacity = 1;
        self.$outline.style.opacity = 1;
      } else {
        self.$dot.style.opacity = 0;
        self.$outline.style.opacity = 0;
      }
    },
  };

  cursor.init();
} //fin siIndex
